import styled, { css } from "styled-components"
import { breakpoints } from "@config/theme"
import { Box } from "@components/Layout"
import { rgba } from "polished"
import { Cross, ArrowLeft } from "@components/Icons"

export const Sidebar = styled(Box)<{ variant: string; open: boolean }>`
  background: white;
  position: fixed;
  box-shadow: -1px 0px 9px rgba(0, 0, 0, 0.04);
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.5s cubic-bezier(0.23, 1, 0.32, 1);
  z-index: ${(p) => p.theme.zIndex.sidebar};
  transform: translateX(100%);

  @media screen and (min-width: ${breakpoints.small}) {
    max-width: 24rem;

    ${(p) =>
      p.variant === "wide" &&
      css`
        max-width: 52rem;
      `}
  }

  ${(p) =>
    p.open &&
    css`
      transform: translateX(0%);
    `}
`

export const Footer = styled(Box)`
  height: 4.5rem;
`

export const Header = styled(Box)`
  background: white;
`

export const Content = styled(Box)`
  width: 100%;
  height: 100%;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: fixed;
  background: white;
  top: 0;
  padding: 9rem 2rem 6.5rem 2rem;
  z-index: -1;

  @media screen and (max-width: ${breakpoints.small}) {
    padding: 9rem 1rem 6.5rem 1rem;
  }
`

export const Overlay = styled.div<{ show: boolean }>`
  position: fixed;
  transform: translate3d(0, 0, 0);
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s ease-in-out;
  background: ${(p) => p.theme.colors.text.dark};
  z-index: ${(p) => p.theme.zIndex.overlaySidebar};

  ${(p) =>
    p.show &&
    css`
      opacity: 0.2;
      visibility: visible;
    `}
`

export const CloseEl = styled(Cross)`
  fill: ${(p) => p.theme.colors.text.dark};
  height: 1.25rem;
  width: 1.25rem;
`

export const BackEl = styled(ArrowLeft)`
  fill: ${(p) => p.theme.colors.text.dark};
  width: 1.5rem;
  height: 1.5rem;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: translateX(-0.25rem);
  }
`

export const Button = styled.button`
  margin: 0;
  padding: 0;
  width: 1.6rem;
  height: 1.6rem;
  background: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  color: inherit;
  cursor: pointer;
  outline: 0;
  span {
    background: currentColor;
  }
`

export const HeaderEl = styled(Box)<{ showBorder: boolean }>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 2rem;
  height: 5.5rem;
  align-items: center;

  @media screen and (max-width: ${breakpoints.small}) {
    padding: 2rem 1rem;
  }

  ${(x) =>
    x.showBorder &&
    css`
      border-bottom: 1px solid ${(p) => rgba(p.theme.colors.text.dark, 0.2)};
    `}
`
